import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoQuoteLeft16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M5.92063 3.00002C5.88744 2.99971 5.85389 3.0027 5.82004 3.0093C5.76529 3.02005 3.74075 3.36959 2.3425 5.04934C1.1585 6.46909 1.06946 7.87545 1.00071 8.88821C0.998747 8.91683 1.00129 8.94433 1.00315 8.97219C1.00303 8.98384 1.00168 8.99518 1.00168 9.00686C1.00168 10.4676 1.95708 12.2205 4.28733 12.2207C6.06958 12.2207 7.44162 10.8964 7.44162 9.00686C7.44162 7.76061 6.88155 5.79299 4.36155 5.79299C3.86685 5.79299 3.41559 5.88017 3.01389 6.03567C3.07706 5.94401 3.14323 5.85205 3.21457 5.75979C3.91932 4.85029 5.02844 4.22438 6.03244 3.98488C6.29119 3.92263 6.45748 3.66733 6.40598 3.40383C6.3596 3.16692 6.15293 3.00217 5.92063 3.00002ZM13.4206 3.00002C13.3874 2.99971 13.3539 3.0027 13.32 3.0093C13.2653 3.02005 11.2408 3.36959 9.8425 5.04934C8.6585 6.46909 8.56946 7.87545 8.50071 8.88821C8.49875 8.91683 8.50129 8.94433 8.50315 8.97219C8.50303 8.98384 8.50168 8.99518 8.50168 9.00686C8.50168 10.4676 9.45708 12.2205 11.7873 12.2207C13.5696 12.2207 14.9416 10.8964 14.9416 9.00686C14.9416 7.76061 14.3815 5.79299 11.8615 5.79299C11.3669 5.79299 10.9156 5.88017 10.5139 6.03567C10.5771 5.94401 10.6432 5.85205 10.7146 5.75979C11.4193 4.85029 12.5284 4.22438 13.5324 3.98488C13.7912 3.92263 13.9575 3.66733 13.906 3.40383C13.8596 3.16692 13.6529 3.00217 13.4206 3.00002Z" fill={iconColor} /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoQuoteLeft16;